import React, {Component} from 'react';
import MatchWhenLoggedIn from './../MatchWhenLoggedIn';
import {Route, Redirect} from 'react-router-dom';
import AttivitaUserContainer from './AttivitaUserContainer'

class AttivitaContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (<div>
      <Route exact path='/app/attivita' render={() => (
          <Redirect
              to='/app/attivita/usercontainer'
          />
      )} />
      <MatchWhenLoggedIn path='/app/attivita/usercontainer' component={AttivitaUserContainer} />

    </div>)
  }
}

export default AttivitaContent;




/** WEBPACK FOOTER **
 ** ./src/components/attivita/AttivitaContent.js
 **/